module.exports = __webpack_public_path__ + "startpage-746fed5a/google-play-badge-en-4dec7673e59a599e41fe224cad0d2e6f.png";